import React from 'react';
import { IconProps } from '.';

const SvgExcel = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#398E3D' d='M2 2h20v20H2V2Z' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M16.5 7.5h-3L12 9.75 10.5 7.5h-3l3 4.5-3 4.5h3l1.5-2.25 1.5 2.25h3l-3-4.5 3-4.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgExcel;
